/* src/app/components/payroll/timesheets/timesheets-add-entries/timesheets-add-entries.component.css */
.custom-width {
  max-width: 160px;
  min-width: 50px;
  display: inline-block;
  margin: 0 6px;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0 !important;
}
.control-height {
  height: 30px;
}
.custom-btn-row {
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-border {
  border: 1px solid red !important;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.ant-checkbox-wrapper.error-class {
  border: 1px solid red !important;
}
/*# sourceMappingURL=timesheets-add-entries.component-KUNEWE57.css.map */
